import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { X } from 'react-feather'
import mapData from "./world_map_data.json";

import React, { useState, useRef, useMemo } from "react";

import debounce from "lodash.debounce";

import { Popover, PopoverHeader, PopoverBody, Button } from "reactstrap";

const Map = ({ map, isDarkMode, onViewBrands }) => {
  const [hoveredCountry, setHoveredCountry] = useState(null);
  const [showPopover, setShowPopover] = useState(false);
  const mapRef = useRef(null);
  const markerRef = useRef(null);

  const handleMouseEnter = (geo, country, event) => {
    const isItaly = geo.properties.name?.toLowerCase() === "italy";

    if (country || isItaly) {
      const countryName = geo.properties.name;

      if (hoveredCountry?.name === countryName && showPopover) {
        return;
      }

      setShowPopover(false);


      setHoveredCountry({
        name: countryName,
        count: country,
      });

      const rect = mapRef?.current?.getBoundingClientRect();
      const x = event.clientX - rect?.left;
      const y = event.clientY - rect?.top;

      if (markerRef?.current) {
        markerRef.current.style.left = `${x}px`;
        markerRef.current.style.top = `${y}px`;
        markerRef.current.style.display = "block";
      }

      setShowPopover(true);
    } else {
      setShowPopover(false);
    }
  };

  const handleMouseLeave = () => {
    if (!document.querySelector(".popover:hover")) {
      setShowPopover(false);
      setHoveredCountry(null);
    }
  };

  const debouncedMouseEnter = useMemo(
    () => debounce(handleMouseEnter, 700),
    [hoveredCountry, showPopover]
  );
  const debouncedMouseLeave = useMemo(
    () => debounce(handleMouseLeave, 700),
    [hoveredCountry, showPopover]
  );

  const handlePopoverToggle = () => {
    if (!showPopover) {
      setShowPopover(false);
      setHoveredCountry(null);
      if (markerRef.current) {
        markerRef.current.style.display = "none";
      }
    }
  };

  const handleButtonClick = (callback) => {
    if (callback && hoveredCountry) {
      callback(hoveredCountry);
    }
    setShowPopover(false);
    setHoveredCountry(null);
    if (markerRef.current) {
      markerRef.current.style.display = "none";
    }
  };

  return (
    <div
      ref={mapRef}
      style={{
        maxHeight: "380px",
        overflow: "hidden",
        position: "relative",
      }}
      onMouseLeave={debouncedMouseLeave}
    >
      <div
        ref={markerRef}
        id="popover-marker"
        style={{
          position: "absolute",
          width: "1px",
          height: "1px",
          display: "none",
          pointerEvents: "none",
          zIndex: 1,
        }}
      />

      <ComposableMap
        height={380}
        projectionConfig={{ scale: 140 }}
        style={{ width: "100%", height: "auto" }}
      >
        <Geographies geography={mapData}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const countryName = geo.properties.name?.toLowerCase();
              const country = map[countryName];
              const isItaly = countryName === "italy";
              const fillColor = isItaly
                ? "#FFD700"
                : country
                  ? "#111111"
                  : isDarkMode
                    ? "#888"
                    : "#d1d1d1";

              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  onMouseEnter={(event) =>
                    debouncedMouseEnter(geo, country, event)
                  }
                  onMouseLeave={handleMouseLeave}
                  style={{
                    default: {
                      fill: fillColor,
                      outline: "none",
                    },
                    hover: {
                      fill: fillColor,
                      outline: "none",
                      cursor: country || isItaly ? "pointer" : "default",
                    },
                    pressed: {
                      fill: fillColor,
                      outline: "none",
                    },
                  }}
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>

      <Popover
        isOpen={showPopover}
        placement="top"
        target="popover-marker"
        toggle={handlePopoverToggle}
        trigger="manual"
        delay={0}
      >
        <PopoverHeader style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {hoveredCountry?.name}
          <button className="btn p-0" onClick={() => setShowPopover(false)}>
            <X size={18} />
          </button>
        </PopoverHeader>        <PopoverBody>
          <div className="mb-2">
            <div className="mb-2" style={{ fontSize: "14px" }}>
              Count: {hoveredCountry?.count || 0}
            </div>
          </div>
          <div className="d-flex gap-2 justify-content-center">
            <Button
              color="primary"
              size="sm"
              style={{ borderRadius: "30px" }}
              onClick={() => handleButtonClick(onViewBrands)}
            >
              View
            </Button>
          </div>
        </PopoverBody>
      </Popover>
    </div>
  );
};

export default Map;
